import { render, staticRenderFns } from "./gwp-factors.vue?vue&type=template&id=4c462825&scoped=true"
import script from "./gwp-factors.vue?vue&type=script&lang=js"
export * from "./gwp-factors.vue?vue&type=script&lang=js"
import style0 from "./gwp-factors.vue?vue&type=style&index=0&id=4c462825&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c462825",
  null
  
)

export default component.exports